// TODO: fix typing / vacancyType, or move to other layer
export default function useVacancyTypeName(vacancy?: Vacancy) {
  const { t: $t } = useI18n({ useScope: 'global' })

  const vacancyTypeName = computed(() =>
    $t(
      `vacancy.attributes.vacancyTypeName.${vacancy?.vacancyType || 'volunteering'}.one`,
    ),
  )

  const vacancyTypeNamePlural = computed(() =>
    $t(
      `vacancy.attributes.vacancyTypeName.${vacancy?.vacancyType || 'volunteering'}.multiple`,
    ),
  )

  const vacancyTypeNameCapitalized = computed(() =>
    capitalize(vacancyTypeName.value),
  )

  return {
    vacancyTypeName: vacancyTypeName.value,
    vacancyTypeNamePlural: vacancyTypeNamePlural.value,
    vacancyTypeNameCapitalized: vacancyTypeNameCapitalized.value,
  }
}
